// extracted by mini-css-extract-plugin
export default {"app":"app_app__OsQoD","line":"app_line__Qh8ol","team":"app_team__OZfos","gird":"app_gird__WZvUm"};